module.exports = __webpack_public_path__ + "img/massage-2.953022ec.jpg";